// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { StyledActions } from 'common/components/Actions/Styles';
import {
    Button,
    Icon,
    Translate,
} from '@plesk/ui-library';
import { ICONS } from 'common/constants';
import { dataCySelector } from 'common/tests/selectors';
import { TABLE_ACTIONS } from 'admin/storageTag/constants/tests';
import ButtonWithConfirmation from 'common/components/ButtonWithConfirmation';
import { IStorageTagResponse } from 'common/api/resources/StorageTag';

export interface IStorageTagProps {
    item: IStorageTagResponse;
    handleEdit: () => void;
    handleRemove: () => void;
}

export const StorageTagActions: React.FC<IStorageTagProps> = ({
    item,
    handleEdit,
    handleRemove,
}) => (
    <StyledActions>
        <Button
            ghost={true}
            icon={<Icon name={ICONS.PENCIL} size={18} />}
            tooltip={<Translate content="storageTag.tooltip.edit"/>}
            onClick={handleEdit}
            data-cy={dataCySelector(item.id, TABLE_ACTIONS.EDIT)}
        />
        <ButtonWithConfirmation
            isLoading={item.is_deleting}
            translations={{
                title: (
                    <Translate content="storageTag.removePopover.title" />
                ),
                button: (
                    <Translate content="storageTag.removePopover.button" />
                ),
                tooltip: (
                    <Translate content="storageTag.removePopover.tooltip" />
                ),
            }}
            handleConfirm={handleRemove}
            data-cy={dataCySelector(item.id, TABLE_ACTIONS.REMOVE)}
            icon={ICONS.RECYCLE}
        />
    </StyledActions>
);